import React from 'react';
import StationCell from './StationCell';
import AvailabilityCell from './AvailsCell';

const ShowsGridColumnDefinitions = () => {
    return [
        {
            displayOrder: 1,
            headerName: '',
            field: 'id',
            type: 'hidden',
            hideInColumnFilter: true
        },
        {
            displayOrder: 5,
            headerName: window.translate('Show Name'),
            field: 'name',
            type: 'text',
            width: 'auto',
            hideInColumnFilter: true,
            showInList: true,
            sortable: true,
            sortOrder: 'asc'
        },
        {
            displayOrder: 7,
            headerName: window.translate('Show Type'),
            field: 'showType',
            type: 'text',
            width: 'auto',
            showInList: true,
            sortable: true,
            sortOrder: 'asc'
        },
        {
            displayOrder: 8,
            headerName: window.translate('First Episode Date'),
            field: 'showStartDate',
            type: 'date',
            width: 'auto',
            showInList: true,
            sortable: true,
            sortOrder: 'asc'
        },
        {
            displayOrder: 9,
            headerName: window.translate('Last Episode Date'),
            field: 'showEndDate',
            type: 'date',
            width: 'auto',
            showInList: true,
            sortable: true,
            sortOrder: 'asc'
        },
        {
            displayOrder: 10,
            headerName: window.translate('Frequency'),
            field: 'frequency',
            width: 115,
            type: 'text',
            showInList: true,
            sortable: true,
            sortOrder: 'asc'
        },
        {
            displayOrder: 11,
            headerName: window.translate('Start Time'),
            field: 'fixedTime',
            width: 115,
            type: 'text',
            showInList: true,
            sortable: true,
            sortOrder: 'asc'
        },
        {
            displayOrder: 12,
            headerName: window.translate('Duration'),
            field: 'showLength',
            type: 'text',
            width: 'auto',
            showInList: true,
            sortable: true,
            sortOrder: 'asc'
        },

        {
            displayOrder: 13,
            headerName: window.translate('Standard Airtime'),
            field: 'standardAirtimeText',
            type: 'text',
            width: 'auto',
            showInList: true,
            sortable: true,
            sortOrder: 'asc'
        },
        {
            displayOrder: 14,
            headerName: window.translate('Max Sponsors'),
            field: 'maxSponsors',
            type: 'number',
            width: 'auto',
            showInList: true,
            sortable: true,
            sortOrder: 'asc'
        },
        {
            displayOrder: 15,
            headerName: window.translate('Availability'),
            field: 'sponsorshipAvailsFrom',
            type: 'custom',
            customType: 'component',
            component: (
                <AvailabilityCell
                    fieldName={'sponsorshipAvailsFrom'}
                    compareFieldName={'firstDate'}
                    isStandardAirtimeField={'isStandardAirtime'}
                />
            ),
            width: 'auto',
            showInList: true,
            sortable: true,
            sortOrder: 'asc'
        },
        {
            displayOrder: 16,
            headerName: window.translate('Max Partners'),
            field: 'maxPartners',
            type: 'number',
            width: 'auto',
            showInList: true,
            sortable: true,
            sortOrder: 'asc'
        },
        {
            displayOrder: 17,
            headerName: window.translate('Availability'),
            field: 'partnershipAvailsFrom',
            type: 'custom',
            customType: 'component',
            component: (
                <AvailabilityCell
                    fieldName={'partnershipAvailsFrom'}
                    compareFieldName={'firstDate'}
                    isStandardAirtimeField={'isStandardAirtime'}
                />
            ),
            width: 'auto',
            showInList: true,
            sortable: true,
            sortOrder: 'asc'
        },
        {
            displayOrder: 18,
            headerName: window.translate('Stations'),
            field: 'stationList',
            type: 'custom',
            customType: 'component',
            component: <StationCell fieldName={'stationList'} />,
            width: 'auto',
            showInList: true,
            sortable: true,
            sortOrder: 'asc'
        }
    ];
};

export default ShowsGridColumnDefinitions;
